import React from "react";

const SVG = ({
    style = {},
    width = "100%",
    className = "",
    viewBox = "0 0 324.27 253.12"
}) => (
    <svg
        width={width}
        style={style}
        height={width}
        viewBox={viewBox}
        xmlns="http://www.w3.org/2000/svg"
        className={className || ""}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path d="M236.77 39.1l-3.31-3.31-3.15 3.15-3.16-3.15-3.31 3.31 3.15 3.16-3.15 3.15 3.31 3.31 3.16-3.15 3.15 3.15 3.31-3.31-3.15-3.15 3.15-3.16z" fill="#ff723b" />
        <path d="M34.46 158.31L31.15 155 28 158.15 24.84 155l-3.31 3.31 3.15 3.15-3.15 3.16 3.31 3.31 3.16-3.15 3.15 3.15 3.31-3.31-3.15-3.16 3.15-3.15z" fill="#ff723b" />
        <path d="M94.68 17.18l-3.31-3.32-3.16 3.16-3.15-3.16-3.32 3.32 3.16 3.15-3.16 3.16 3.32 3.31 3.15-3.16 3.16 3.16 3.31-3.31-3.15-3.16 3.15-3.15z" fill="#ff723b" />
        <path d="M302.78 182.59l-3.31-3.31-3.16 3.16-3.16-3.16-3.31 3.31 3.16 3.16-3.16 3.15 3.31 3.32 3.16-3.16 3.16 3.16 3.31-3.32-3.16-3.15 3.16-3.16z" fill="#ff723b" />
        <path d="M34.46 53.56a4.84 4.84 0 1 1 4.84-4.84 4.84 4.84 0 0 1-4.84 4.84zm0-7.67a2.84 2.84 0 1 0 2.84 2.83 2.83 2.83 0 0 0-2.84-2.83z" fill="#ff723b" />
        <path d="M174.87 9.67a4.84 4.84 0 1 1 4.84-4.84 4.84 4.84 0 0 1-4.84 4.84zm0-7.67a2.84 2.84 0 1 0 2.84 2.83A2.83 2.83 0 0 0 174.87 2z" fill="#ff723b" />
        <path d="M310.39 77.38a4.84 4.84 0 1 1 4.83-4.83 4.84 4.84 0 0 1-4.83 4.83zm0-7.67a2.84 2.84 0 1 0 2.83 2.84 2.84 2.84 0 0 0-2.83-2.84z" fill="#ff723b" />
        <path d="M248.74 157.15a4.83 4.83 0 1 1 4.84-4.83 4.84 4.84 0 0 1-4.84 4.83zm0-7.66a2.83 2.83 0 1 0 2.84 2.83 2.83 2.83 0 0 0-2.84-2.83z" fill="#ff723b" />
        <path d="M81.74 218.29a4.83 4.83 0 1 1 4.84-4.83 4.83 4.83 0 0 1-4.84 4.83zm0-7.66a2.83 2.83 0 1 0 2.84 2.83 2.83 2.83 0 0 0-2.84-2.83z" fill="#ff723b" />
        <path d="M324.27 140.58a4.53 4.53 0 1 1-4.52-4.52 4.52 4.52 0 0 1 4.52 4.52z" fill="#ff723b" />
        <path d="M9 82.68a4.52 4.52 0 1 1-4.52-4.52A4.52 4.52 0 0 1 9 82.68z" fill="#ff723b" />
        <path d="M234.83 82.68a4.53 4.53 0 1 1-4.53-4.52 4.52 4.52 0 0 1 4.53 4.52z" fill="#ff723b" />
        <path d="M50.34 152.7v-21.08H9v-16.83L56.42 54H69.3v60.68h12.44v17H69.3v21.02zM28 114.65h24.46v-32z" fill="#fff" />
        <path d="M271.09 152.7v-21.08h-41.3v-16.83L277.17 54H290v60.68h12.45v17H290v21.02zm-22.35-38h24.47v-32z" fill="#fff" />
        <path d="M230.35 159.36l.37-.34a1.37 1.37 0 0 0 .09-1.94l-7.59-8.28a61.72 61.72 0 1 0-14.41 13.2l7.58 8.29a1.37 1.37 0 0 0 1.94.08l.37-.34 56.22 61.42h21.39z" fill="#212121" opacity="0.15" />
        <path d="M303.12 238.92l-91.58-91.59-11.78 11.77 91.59 91.59a8.33 8.33 0 0 0 12.24-.51 8.33 8.33 0 0 0-.47-11.26z" fill="#424242" />
        <path d="M191.27 153.42l11.06 11.05a1.43 1.43 0 0 0 2 0l12.54-12.53a1.46 1.46 0 0 0 0-2.05l-11.06-11z" fill="#e0e0e0" />
        <path d="M207.6 140.58l1.4 1.41-11.84 17.31-5.21-5.21 15.65-13.51z" fill="#bdbdbd" />
        <path d="M204.75 164.09l11.78-11.77.8.8-9.2 14.35-3.38-3.38z" fill="#212121" opacity="0.64" />
        <path d="M155.77 38.21a65.12 65.12 0 1 0 65.12 65.12 65.12 65.12 0 0 0-65.12-65.12zm0 116.79a51.67 51.67 0 1 1 51.66-51.67A51.66 51.66 0 0 1 155.77 155z" fill="#f5f5f5" />
        <path d="M121.48 69.05c-7.47 7.47-12 15.09-10 17s9.56-2.56 17-10 12-15.09 10-17-9.48 2.52-17 10z" fill="#fff" />
        <circle cx="90.65" cy="51.67" fill="#ff723b" r="8.99" />
        <circle cx="95.12" cy="155.15" fill="#ff723b" r="4.52" />
        <circle cx="220.89" cy="208.63" fill="#ff723b" r="6.8" />
        <circle cx="155.77" cy="103.33" fill="#da5626" opacity="0.8" r="51.66" />
    </svg>
);

export default SVG;